(function() {
  angular.module('forgotPassword')
  .factory('resetPasswordFactory', ['$resource', function($resource) {
    return $resource('/resetPassword');
  }])
  .factory('ResetEmail', ['$resource', '$log',
  function($resource, $log) {
    return function(guid) {
      return $resource('/dnUsers/:userId',{userId:'@userId'},{
        reset: {method: 'POST',
          headers: {'x-password-reset-token': guid},
        }
      });
    };
  }]);
})();
